function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E21B1B"
    },
    cx: 256,
    cy: 256,
    rx: 256,
    ry: 255.832
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 228.021,
    y: 113.143,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.0178 256.0051)",
    style: {
      fill: "#FFFFFF"
    },
    width: 55.991,
    height: 285.669
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.164,
    y: 227.968,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -106.0134 255.9885)",
    style: {
      fill: "#FFFFFF"
    },
    width: 285.669,
    height: 55.991
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCancel);
export default __webpack_public_path__ + "static/media/red-cancel.9466f18a24dcddf86ca0c07b8677a01f.svg";
export { ForwardRef as ReactComponent };